/* eslint-disable react-hooks/exhaustive-deps */
import PropTypes from "prop-types";
import { Children, cloneElement, useEffect, useRef, useState } from "react";
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import styles from "./index.module.scss";
import { classNames } from "common/functions";
import { HiOutlineChevronRight } from "@react-icons/all-files/hi/HiOutlineChevronRight";

function NextArrow(props) {
  const { onClick } = props;
  return (
    <div
      className={`absolute top-1/2 left-1/2 hidden w-full -translate-x-1/2 -translate-y-1/2 lg:flex`}
    >
      <div
        className={`g-button-next ${styles.btn} ${styles["btn-next"]} `}
        onClick={onClick}
      >
        <HiOutlineChevronRight size={20} className="text-red-400" />
      </div>
    </div>
  );
}

function PrevArrow(props) {
  const { onClick } = props;
  return (
    <div
      className={`absolute top-1/2 left-1/2 hidden w-full -translate-x-1/2 -translate-y-1/2 lg:flex`}
    >
      <div
        className={`g-button-prev ${styles.btn} ${styles["btn-prev"]} `}
        onClick={onClick}
      >
        <HiOutlineChevronRight size={18} className="rotate-180 text-red-400" />
      </div>
    </div>
  );
}

const NormalSlider = ({ settings, children, wrapper, ...props }) => {
  const sliderRef = useRef(null);
  const [hasSetPosition, setHasSetPosition] = useState(false);

  useEffect(() => {
    if (sliderRef.current && !hasSetPosition) {
      sliderRef.current?.slickGoTo(settings.initialSlide);
      setHasSetPosition(true);
    }
  }, [hasSetPosition, sliderRef]);

  settings.dotsClass = styles["slick-dots-normal"];

  settings.appendDots = (dotList) => {
    return (
      <ul>
        {dotList.map((dot, idx) => {
          if (dot.props["className"] === "slick-active") {
            return cloneElement(dot, {
              className: `slick-active`,
              onClick: () => {
                goToSlide(idx);
              },
            });
          } else {
            return cloneElement(dot, {
              className: "",
              onClick: () => {
                goToSlide(idx);
              },
            });
          }
        })}
      </ul>
    );
  };
  settings.customPaging = (i) => <button>{i}</button>;

  if (settings.arrows) {
    if (!settings.nextArrow) {
      settings.nextArrow = <NextArrow />;
    }
    if (!settings.prevArrow) {
      settings.prevArrow = <PrevArrow />;
    }
  }

  const goToSlide = (index) => {
    sliderRef.current && sliderRef.current.slickGoTo(index);
  };
  return (
    <>
      <div className="relative" {...wrapper}>
        <Slider
          ref={sliderRef}
          dots={true}
          arrows={false}
          className={classNames(
            styles["g-slider-normal"],
            props.autoHeight
              ? styles["g-slider-normal-auto-h"]
              : styles["g-slider-normal-full-h"],
            props.customClass
          )}
          {...settings}
        >
          {children &&
            Children.count(children) > 0 &&
            Children.map(children, (element, idx) => {
              return (
                <>
                  {cloneElement(element, {
                    // ref: createRef(idx),
                    className: `mx-auto ${!settings.adaptiveHeight && "h-full"
                      }`,
                  })}
                </>
              );
            })}
        </Slider>
      </div>
    </>
  );
};

NormalSlider.propTypes = {
  settings: PropTypes.object,
  children: PropTypes.any,
  wrapper: PropTypes.object,
};

NormalSlider.defaultProps = {
  settings: {},
  children: <></>,
  wrapper: {},
};

export default NormalSlider;
